import { render, staticRenderFns } from "./NavCategoriesLayout.vue?vue&type=template&id=2ab8f3e8&scoped=true&"
import script from "./NavCategoriesLayout.vue?vue&type=script&lang=js&"
export * from "./NavCategoriesLayout.vue?vue&type=script&lang=js&"
import style0 from "./NavCategoriesLayout.vue?vue&type=style&index=0&id=2ab8f3e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab8f3e8",
  null
  
)

export default component.exports